/* Network Toaster component*/
/* Error Messge will be displayed when app goes offline. */
import React from 'react';
import "./NetworkErrorToaster.scss";
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getNetworkStatus } from '../../selectors/selector';
import { useTranslation } from 'react-i18next';

const NetworkErrorToaster = (props: any) => {
  const { t } = useTranslation();
  return (
    <>
      {!props.isNetworkAvailable
        ? <div className="no-network-div">{t('CHECK_NETWORK_MESSAGE')}</div>
        : null}
    </>
  )
}

const mapStateToProps = createStructuredSelector({
  isNetworkAvailable: getNetworkStatus(),
});


export default connect(mapStateToProps, null)(NetworkErrorToaster);
